import React from 'react';

import styles from './JumbotronButtonArea.module.scss';

type Props = Required<React.PropsWithChildren>;

const JumbotronButtonArea: React.FC<Props> = ({ children }) => (
  <div className={styles.buttonArea}>{children}</div>
);

export default JumbotronButtonArea;
